<template>
  <div class="case-box">
    <div class="bgPic">
      <div class="picText">
        <span class="title">数字化运营服务商，全渠道数字化信息平台</span><br />
        <span>为企业提供专业、高效的服务</span>
      </div>
    </div>
    <!-- ..................... -->
    <!-- 成果 -->
    <div class="achieve-box">
      <!-- <div class="first">
        <p>数字化营销方案服务商</p>
        <span>实现行业内领先的业务流和数据流闭环</span><br />
        <span>——任务下发、触达回访、结果分析</span>
        <div class="pic">
          <img src="../assets/last/certificate/业务流 数据流 闭环.png" alt="" />
        </div>
      </div> -->
<div class="caseBox">
    <!-- AIAM -->
    <!-- <div class="proValue">
<div class="title">AIAM系统</div>
<div class="valueItem">
        <el-row>
          <el-col
            :span="5"
            v-for="(item, index) in punchArr"
            :key="index"
            :offset="index > 0 ? 1 : 0"
          >
            <el-card :body-style="{ padding: '30px 10px', height: '150px' }">
              <el-avatar :size="60" :src="item.imgs"></el-avatar>
              <div><br>
                <p>{{ item.info }}</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="allPreview">
        <div class="title">
            AIAM系统功能图
        </div>
       <img src="../assets/last/AIAM/大图.png" alt="" />
   </div> -->
    <!-- AICM -->
    <div class="banner">
        <div class="title">
            <div>助力线上线下零售企业数字化</div>
        <div>智能会员营销方案</div>
        <span>数据+智能：帮助企业高效实践数字增长</span>
        </div>
    </div>
    
    <!-- 产品核心价值 -->
    <div class="proValue">
<div class="title">产品核心价值</div>
<div class="valueItem">
        <el-row>
          <el-col
            :span="5"
            v-for="(item, index) in valueArr"
            :key="index"
            :offset="index > 0 ? 1 : 0"
          >
            <el-card :body-style="{ padding: '30px 10px', height: '150px' }">
              <el-avatar :size="60" :src="item.imgs"></el-avatar>
              <div><br>
                <p>{{ item.info }}</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="allPreview">
        <div class="title">
            会员系统经营全景图
        </div>
        <img src="../assets/last/AICM/表格.png" alt="" style="height: 600px;" />
    </div>
    <div class="allPreview" style="background-color: #fff;">
        <div class="title">
            业务流数据流闭环
        </div>
        <img src="../assets/last/AICM/闭环.png" alt="" style="height: 600px;" />
    </div>
    <div class="allPreview">
        <div class="title">
            功能介绍-后台系统
        </div>
        <img src="../assets/last/AICM/展示.png" alt="" style="height: 1000px;" />
    </div>
    <div class="allPreview" style="background-color: #fff; padding-bottom:0; ;">
        <div class="title">
            功能介绍-导购助手
        </div>
        <!-- <div class="image"></div> -->
        <img src="../assets/last/AICM/展示3.png" alt="" style="width: 100%;" />
    </div>
</div>


      <div class="second">
        <img src="../assets/last/certificate/AICM项目5大成果.png" alt="" />
      </div>
      <div class="third">
        <b class="title">数据+智能-助力企业高效实践数字化增长</b><br />
        <p>AICM智能会员管理系统</p>
        <div class="third-item">
          <div><span>940万 回访任 务总量</span></div>
          <div><span>导购参 与率 70%</span></div>
          <div><span>覆盖 378万 会员</span></div>
          <div><span>人均完 成532 个任务</span></div>
        </div>
      </div>
      <div class="fouth">
        <p>服务伙伴</p>
        <div class="fouth-item">
          <div class="item" @mouseenter="enter(1)" @mouseleave="leave(1)">
          <!-- <img src="../assets/last/brand/音儿logo图.png" alt="" /> -->
            <div class="img" :style="{ backgroundImage: 'url(' + require('@/assets/last/brand/音儿logo图.png')+')','background-size': '100% auto'}"></div>
            <div class="itemInfo" v-if="disabled1">
              <img src="../assets/last/brand/音儿logo.png" alt="" /><br />
              <span
                >YINER音儿是中国知名时尚消费品牌,集研发、创意、营销、服务于一体.YINER音儿以“因爱而生
                , 因您而美” 为品牌使命，塑造“爱是永不止息”的 品牌核心理念
                ,为职场精英女性打造 融合中西审美的知性生活方式。</span
              >
            </div>
          </div>
          <div class="item" @mouseenter="enter(2)" @mouseleave="leave(2)">
            <!-- <div><img src="../assets/last/brand/恩裳logo图.png" alt="" /></div> -->
            <div class="img" :style="{ backgroundImage: 'url(' + require('../assets/last/brand/恩裳logo图.png')+')','background-size': '100% auto'}"></div>

            <div class="itemInfo" v-if="disabled2">
              <img src="../assets/last/brand/恩裳logo.png" alt="" /><br />
              <span
                >INSUN恩裳以“简约•生活的艺术”为原则，
                开始在时装领域编织独特风格的霓裳，
                成为简约精神的传播者与现代艺术女装的 先行者。</span
              >
            </div>
          </div>
          <div class="item" @mouseenter="enter(3)" @mouseleave="leave(3)">
            <div class="img" :style="{ backgroundImage: 'url(' + require('../assets/last/brand/ʫƪlogoͼ.png')+')','background-size': '100% auto'}"></div>
            <div class="itemInfo" v-if="disabled3">
              <img src="../assets/last/brand/ʫƪlogo.png" alt="" /><br />
              <span
                >“ 你的存在，生命的意义 ”，PSALTER诗篇
                为歌颂生命意义而生，倡导中国式的中产
                阶层的贵族精神，为都市精英女性创造更 美好的人生而存在。</span
              >
            </div>
          </div>
        </div>
        <div class="fouth-item">
          <div class="item" @mouseenter="enter(4)" @mouseleave="leave(4)">
            <div class="img" :style="{ backgroundImage: 'url(' + require('../assets/last/brand/歌中歌logo图.png')+')','background-size': '100% auto'}"></div>
            <div class="itemInfo" v-if="disabled4">
              <img src="../assets/last/brand/歌中歌logo.png" alt="" /><br />
              <span
                >Song of Song歌中歌，奢华、优雅、
                永恒的代名词。她汲取法国百年文化
                艺术之美,荟萃中国制造尖端技艺,创
                造时代风尚。以高定艺术的极致追求， 倾尽所有，为你最美。</span
              >
            </div>
          </div>
          <div class="item" @mouseenter="enter(5)" @mouseleave="leave(5)">
            <div class="img" :style="{ backgroundImage: 'url(' + require('../assets/last/brand/奥丽嘉朵logo图.png')+')','background-size': '100% auto'}"></div>
            <div class="itemInfo" v-if="disabled5">
              <img src="../assets/last/brand/奥丽嘉朵logo.png" alt="" /><br />
              <span
                >OBBLIGATO奥丽嘉朵以现代、柔美、
                力量为主线，以精美绝伦的剪裁，极
                富创意的设计，应用高级面料，体现
                新时代女性柔美外表下的坚定执着、
                自我态度以及柔美主义风格。</span
              >
            </div>
          </div>
          <div class="item" @mouseenter="enter(6)" @mouseleave="leave(6)">
            <div class="img" :style="{ backgroundImage: 'url(' + require('../assets/last/brand/十二篮logo图.png')+')','background-size': '100% auto'}"></div>
            <div class="itemInfo" v-if="disabled6">
              <img src="../assets/last/brand/十二篮logo.png" alt="" /><br />
              <span
                >XII BASKET十二篮以复古焕新的理念
                让现代女性与贵族运动服装之间形成
                深厚的情感连接，打破大众对运动休 闲服饰的常规认知。</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foote">
      <div class="first" style="text-align: center; padding-top: 30px">
        <h1>合作伙伴</h1>
        <img src="../assets/last/合作伙伴logo.png" alt="" style="height: 500px" />
      </div>
    </div>
    <!-- <div class="foot"></div> -->
     <BottomFooter />

  </div>
</template>

<script>
import BottomFooter from './bottom.vue'
export default {
  name: "EcellentCase",
  components: {
    BottomFooter
  },
  data() {
    return {
      disabled1: false,
      disabled2: false,
      disabled3: false,
      disabled4: false,
      disabled5: false,
      disabled6: false,

      bannerHeight: 500,
      brandImgs1: [
        { imgs: require("../assets/last/brand/音儿logo图.png") },
        { imgs: require("../assets/last/brand/恩裳logo图.png") },
        { imgs: require("../assets/last/brand/诗篇logo图.png") },
      ],
      brandImgs2: [
        { imgs: require("../assets/last/brand/歌中歌logo图.png") },
        { imgs: require("../assets/last/brand/奥丽嘉朵logo图.png") },
        { imgs: require("../assets/last/brand/十二篮logo图.png") },
      ],
      punchArr:[
      {
          imgs: require("../assets/last/AIAM/a.png"),
          info: ` 上千家门店，5000多名员工，跨门店打卡`
        },
        {
          imgs: require("../assets/last/AIAM/b.png"),
          info: ` 人脸识别，活体检测`
        },
        {
          imgs: require("../assets/last/AIAM/c.png"),
          info: ` 绑定门店设备`
        },
        {
          imgs: require("../assets/last/AIAM/d.png"),
          info: ` 异常打卡状态检测`
        }
      ],
      valueArr: [
        {
          imgs: require("../assets/last/AICM/01.png"),
          info: ` 基于业务流、数据流、赋能终端的营销闭环`
        },
        {
          imgs: require("../assets/last/AICM/02.png"),
          info: ` 商业价值、智能推荐模型`
        },
        {
          imgs: require("../assets/last/AICM/03.png"),
          info: ` 渠道会员体系互通一体化`
        },
        {
          imgs: require("../assets/last/AICM/04.png"),
          info: ` 大数据驱动柔性经营体系`
        }
    ]
    };
  },

  mounted() {},

  methods: {
    enter(type) {
      switch (type) {
        case 1:
          this.disabled1 = true;
          break;
        case 2:
          this.disabled2 = true;
          break;
        case 3:
          this.disabled3 = true;
          break;
        case 4:
          this.disabled4 = true;
          break;
        case 5:
          this.disabled5 = true;
          break;
        case 6:
          this.disabled6 = true;
          break;
        default:
          break;
      }
    },
    leave(type) {
      switch (type) {
        case 1:
          this.disabled1 = false;
          break;
        case 2:
          this.disabled2 = false;

          break;
        case 3:
          this.disabled3 = false;
          break;
        case 4:
          this.disabled4 = false;
          break;
        case 5:
          this.disabled5 = false;
          break;
        case 6:
          this.disabled6 = false;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.case-box{    
    // overflow-y: hidden;去除垂直滚动
    overflow-x: hidden;//去除水平滚动
    // overflow-y: scroll//垂直一直有滚动
}
page{
    font-family: Avenir, Helvetica, Arial, sans-serif; 
}
.bgPic {
  background: url("../assets/last/bg/优秀案例背景.png") no-repeat;
  background-size: cover;
  height: 75vh;
  min-height: 800px !important;
  position: relative;

//   height: 870px;
}
.picText {
  color: rgb(242, 243, 247);
  text-align: center;
  letter-spacing: 3px;
  line-height: 80px;
  font-family: SourceHanSansCN-Regular-;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-80%);

//   padding-top: 300px;
  .title {
    display: inline-block;
    font-size: 50px;
    font-weight: normal;
    letter-spacing: 7px;
    white-space: nowrap;

  }

  span {
    font-size: 35px;
  }
  :hover {
    color: rgba(110, 87, 229);
  }
}

.caseBox{
    position: relative;
    .banner{
        // width: 100%;
    height: 700px;
        background-image: url(../assets/last/AICM/banner.png);
        background-size: contain;
        .title{
            // color: #000;
            font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
            position: relative;
            left:10%;
            top: 20%;
            text-align: left;
            div{font-size: 45px;font-weight: 700;padding: 25px;padding-left: 0;}
            span{font-size: 24px;display: block;padding-top: 20px;
      font-weight: normal;
      color: #6e6d7d;}
        }
    }
.proValue{
    text-align: center;
    margin: 100px 0;
    .title{
        font-size: 30px;
      font-weight: 600;
    }
    .valueItem{
    margin: auto;
    margin-top: 50px;
     width: 1300px;
     p{
        color: #6e6d7d;
     }
     :hover{
      color: #0d7afe;
    }
    }
}
.allPreview{
    padding: 50px 0;
    background-color: #f8f8f8;
.title{
    font-size: 30px;
      font-weight: 600;
      margin: 50px 0;
}
.image{
    width: 100%;
    height: 500px;
    background: url('../assets/last/AICM/展示2.png') no-repeat;
        background-size: cover;

}
}
}

.achieve-box {
  text-align: center;
  line-height: 20px;
  letter-spacing: 3px;

  .first {
    padding: 40px 0;
    border-bottom: 1px dotted #999;

    p {
      font-size: 30px;
      font-weight: 600;
    }
    span {
      display: inline-block;
      padding-bottom: 5px;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
      font-weight: normal;
      color: #6e6d7d;
    }
    img {
      width: 40%;
    }
  }
  .second {
    border-bottom: 1px dotted #999;
    background-color: rgb(248, 248, 248);
    img {
      // height: 600px;
      width: 80%;
    }
  }
  .third {
    padding: 70px 0;
    // border-bottom: 1px dotted #999;
    b {
      font-size: 30px;
      font-weight: 600;
    }
    p {
      letter-spacing: 2px;
      font-size: 22px;
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
      font-weight: normal;
      color: #666666;
    }
  }
  .third-item {
    font-size: 22px;
    padding: 40px 0;
    display: flex;
    justify-content: space-between;
    // justify-content: center;

    width: 60%;
    margin: 0 auto;
    div {
      position: relative;
      width: 150px;
      height: 150px;
      border-radius: 75px;
      //  font-size: 0.3vw;
      font-weight: 400;
      background-color: rgb(58, 106, 255);
      span {
        color: #fff;
        display: block;
        line-height: 30px;
        position: absolute;
        top: 21%;
        left: 17%;
        width: 100px;
      }
      :hover {
        color: rgb(66, 5, 66);
      }
    }
  }
}
  .fouth {
    padding-top:30px;
    width: 100%;
    // padding: 40px 0px 40px 20px;
    background-color: rgb(248, 248, 248);
    // margin: 0 auto;
    p {
      font-size: 30px;
      font-weight: 600;
    }
    .fouth-item {
      display: flex;
      justify-content: center;
      .item {
        position: relative;
      }
      .img{
        width: 350px;
        height: 373px;
      }
      .itemInfo {
        position: absolute;
        padding: 10px;
        left: 25px;
        top: 17px;
        text-align: center;
        font-size: 18px;
        line-height: 25px;
        letter-spacing: 1.5px;
        background-color: #fff;
        // background-color: rgba(0,0,0,0.3);
        width: 280px;
        height: 320px;
        span {
          text-align: left;
          display: inline-block;
          padding-top: 35px;
        }
        img{
          width: 100%;
        }
        :hover {
          color: rgb(58, 106, 255);
        }
      }
      // img {
      //   width: 20%;
      // }
    }
  }

// .foot {
//   background: url("../assets/last/bg/底部.png") no-repeat;
//   background-size: contain;
//   height: 480px;
// }
</style>